import { css } from 'emotion';

export const imageWrapper = css`
  max-width: 150px;
  margin: 0 auto 41px;
  pointer-events: none;
  user-select: none;

  & img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

export const mainText = css`
  max-width: 507px;
  margin: 0 auto;
  margin-bottom: 36px;
  line-height: 1.2em;
  font-family: ChronicaPro;
  color: #e3e3e3;
`;

export const buttonWrapper = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: 32px;
`;

export const popup = css`
  overflow: auto;
  width: 640px;
`;
